
import moment, { Moment, unitOfTime } from 'moment'

import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'

@Component
export default class PaceMaker extends Vue {
  @Prop({ type: Number, default: 1 })
  readonly frequency!: number

  @Prop({ type: String, default: 'minute' })
  readonly unit!: unitOfTime.Base

  @Prop({ type: Date })
  readonly keepSubunit?: Date

  @PropSync('now', { type: Object, required: true })
  syncedNow!: Moment

  nowTimeout: NodeJS.Timeout | null = null

  get duration () {
    const time = this.syncedNow.clone().startOf(this.unit)

    if (
      this.keepSubunit === undefined ||
      (this.subunit && this.syncedNow.get(this.subunit) >= this.offset)
    ) {
      time.add(this.frequency, this.unit)
    }

    if (this.keepSubunit) {
      time.add(this.offset, this.subunit)
    }

    return time.diff(this.syncedNow)
  }

  get offset () {
    return this.keepSubunit && this.subunit
      ? moment(this.keepSubunit).get(this.subunit)
      : 0
  }

  get subunit (): unitOfTime.Base | undefined {
    const units: Record<string, unitOfTime.Base> = {
      year: 'month',
      month: 'day',
      day: 'hour',
      hour: 'minute',
      minute: 'second',
      second: 'millisecond'
    }

    return units[moment.normalizeUnits(this.unit)]
  }

  created () {
    this.refreshTimer()
  }

  destroyed () {
    if (this.nowTimeout) {
      clearTimeout(this.nowTimeout)
      this.nowTimeout = null
    }
  }

  refreshTimer () {
    this.nowTimeout = setTimeout(() => {
      if (this.nowTimeout) {
        this.syncedNow = moment()
        this.$nextTick(this.refreshTimer)
      }
    }, this.duration)
  }

  render (createElement: () => void) {
    return createElement()
  }
}
